<div class="mmc-settings-risk-tolerance-container">
    <div class="mmc-settings-risk-tolerance-add-container">
        <div class="mmc-settings-risk-tolerance-add-container-row">
            <div class="mmc-settings-risk-tolerance-add-container-element">
                <div class="mmc-settings-risk-tolerance-add-container-element-input">
                    <input type="text" pInputText [value]="riskToleranceName"
                           autocomplete="off"
                           autocorrect="off"
                           autocapitalize="off"
                           spellcheck="false"
                           placeholder="Enter a risk tolerance"
                           [formControl]="riskToleranceValidationTextBoxInputControl"
                           [(ngModel)]="riskToleranceName"
                           tooltip
                           [tooltipTitle]="inputErrorMessage"
                           [tooltipPosition]="'right'"
                           tooltipClass="error"
                           [tooltipHorizontalOffset]="8"
                           maxlength="70"
                           #riskToleranceValidationTextBox>
                </div>
                <div class="mmc-settings-risk-tolerance-add-container-element-button">
                    <button class="btn-medium-secondary btn-spacer" (click)="onAddRiskTolerance()"
                            [disabled]="(!riskToleranceValidationTextBoxInputControl?.valid ||  !riskToleranceName )">Add
                    </button>
                </div>
            </div>

        </div>
    </div>
    <div class="mmc-counter-label"> {{getNonDeletedCount() + ' Risk Tolerances'}}</div>
    <irb-inventory-grid
            class="mmc-settings-risk-tolerance-grid-ag"
            [style.width]="'100%'"
            [gridHeight]="'240px'"
            [showSideBar]="false"
            [gridOptions]="gridOptions"
            [frameworkComponents]='frameworkComponents'
            [rowData]="data"
            (cellValueChanged)="onCellValueChanged($event)"
            (gridReady)="onGridReady($event)"></irb-inventory-grid>
</div>


